import React, { FunctionComponent } from 'react';
import Layout from '../../containers/layout';

const CareerResources: FunctionComponent = () => (
  <Layout showImageHeader imageHeaderPath="/images/pattern-about.png">
    <div className="lg:w-7/12 pt-32 mx-auto text-sm">
      <hr />
      <p className="mt-8">
        There are some of the career resources website that
        we think will be beneficial to the STEM community:
      </p>
      <h1 className="mt-8 text-3xl font-bold">STEMPeers PUBLICATIONS</h1>
      <ol className="list-decimal list-inside mt-8 leading-loose career-resources__links career-resources__links--bold">
        <li>
          <a className="font-bold text-blue-link" href="https://www.sciwri.club/archives/3035">
            Social Media-based Career Mentoring- The Do’s and Dont’s
          </a>
          - Anshu Malhotra
        </li>
        <li>
          <a href="https://www.sciwri.club/archives/4141">
            Let’s start with the first stepping stone
          </a>
          - Rituparna Chakrabarti
        </li>
        <li>
          <a href="https://www.sciwri.club/archives/5575">
            CSG Gurukool&apos;s Wins in 2017!
          </a>
          - Dolonchapa Chakraborty
        </li>
        <li>
          <a href="https://www.sciwri.club/archives/1286">
            A job transition or a leap ahead?
          </a>
          - Satarupa Das
        </li>
        <li>
          <a href="https://www.sciwri.club/archives/1286">
            Scientists without Borders: Club SciWri
          </a>
          - Imit Kaur
        </li>
        <li>
          <a href="http://genestogenomes.org/ananda-ghosh-on-finding-your-niche/">
            Finding your niche
          </a>
          - Ruchi Johnsa
        </li>
        <li>
          <a href="https://indiabioscience.org/columns/indian-scenario/networking-for-navigating-the-landscape-of-science-jobs">
            Networking for Navigating the landscape of Science Careers
          </a>
          - Siddharth Kankaria
        </li>
        <li>
          <a href="http://blogs.nature.com/indigenus/2019/06/sciart-scribbles-science-history-and-comics.html">
            SciArt scribbles: Science, history and comics
          </a>
          - Argha Manna
        </li>
      </ol>
      <h2 className="uppercase text-xl font-bold mt-8">
        Useful other websites on stem career development
      </h2>
      <ul className="list-disc list-inside leading-loose mt-4 career-resources__links">
        <li>
          <a href="https://blog.addgene.org/">
            Addgene Blogs
          </a>
        </li>
        <li>
          <a href="https://www.ascb.org/career-development-subcommittee/">
            ASCB Career Development Resources
          </a>
        </li>
        <li>
          <a href="https://www.asm.org/index.php/build-your-skills">
            American Society of Microbiology Career Resources
          </a>
        </li>
        <li>
          <a href="https://community.beyondprof.com/">
            Beyond the Professoriate
          </a>
        </li>
        <li>
          <a href="https://cheekyscientist.com/">
            Cheeky Scientist
          </a>
        </li>
        <li>
          <a href="https://www.docjobs.com/">
            DocJobs
          </a>
        </li>
        <li>
          <a href="http://www.edsjoblist.com/">
            Ed&apos;s Job List
          </a>
        </li>
        <li>
          <a href="http://www.genetics-gsa.org/careers/MaPD.shtml">
            Genetics Society of America
          </a>
        </li>
        <li>
          <a href="http://jobsontoast.com/about-jobs-on-toast/">
            Jobs on Toast
          </a>
        </li>
        <li>
          <a href="http://myidp.sciencecareers.org/">
            myIDP
          </a>
        </li>
        <li>
          <a href="http://mitcommlab.mit.edu/broad/use-the-commkit/">
            MIT Communications Lab-MIT-BROAD Career Development Resources
          </a>
        </li>
        <li>
          <a href="https://www.training.nih.gov/assets/Career_Symposium_2015_Newsletter__508.pdf">
            NIH Career Symposium Newsletter 2015
          </a>
        </li>
        <li>
          <a href="https://www.training.nih.gov/career_services#Career%20Programs%20and%20Resources">
            NIH Career Development Resources
          </a>
        </li>
        <li>
          <a href="http://www.sciwri.club/">
            Club Sciwri-Official blog of PhDCSG
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/thesciencetimes/?hl=en">
            The Sciencetimes- PhDCSG&apos;s Scicomm portal on Instagram
          </a>
        </li>
        <li>
          <a className="text-xl font-bold" href="https://www.thesocialscientist.org/">
            The Social Scientist:
          </a>
          {' '}
          <span className="text-xl font-bold">A new outreach community for the scientific field</span>
          <p className="ml-4">
            The idea behind this are the many issues we face trying to connect with others,
            especially those not directly in our discipline. What our field is missing
            are people who can give a complete view of their work, environment and what
            it took for them to get there. Instead of cold calling or trying blindly to
            have people respond to your messaging, these contacts (in various scientific
            and alternative career positions) are readily available and willing to speak
            on their experiences and advice. Volunteers at The Social Scientist are
            dedicated to help you in any way they can. They want to support everyone
            from high school students to associate professors passionate about science.
            Contact their science professionals to set up an informal chat today!
            {' '}
            <a href="https://www.thesocialscientist.org/">
              https://www.thesocialscientist.org/
            </a>
            {' '}
            Goals: -To support all generations
            passionate about science -To provide contacts in various scientific
            positions that are readily available and willing to speak on their experiences
            -To create an engaging yet open atmosphere Interested in being a volunteer?
            This is a great outreach opportunity for you to show your commitment to
            better the scientific field. You can inquire about becoming a volunteer on
            the site (Interest in Joining page) or contact them directly
            {' '}
            <a href="mailto:thesocialscientist.org@gmail.com">
              thesocialscientist.org@gmail.com.
            </a>
          </p>
        </li>
        <li>
          <a href="http://med.stanford.edu/rmg/funding/">
            Stanfort University Funding Resource
          </a>
        </li>
        <li>
          <a href="https://versatilephd.com/">
            The Versatile PhD
          </a>
        </li>
        <li>
          <a href="https://blog.addgene.org/tips-for-getting-a-faculty-position">
            Tips for Getting a Faculty Position
          </a>
        </li>
      </ul>
      <h2 className="uppercase text-xl font-bold mt-8">
        Tools for Scientists
      </h2>
      <ul className="list-disc list-inside career-resources__links mt-4">
        <li>
          <a href="https://www.benchsci.com/">
            BenchSci
          </a>
          - AI driven Antibody Search
        </li>
      </ul>
      <h2 className="uppercase text-xl font-bold mt-8">Policy</h2>
      <a className="text-blue-link mt-4" href="http://futureofresearch.net/">
        Future of Research
      </a>
      <h2 className="uppercase text-xl font-bold mt-8">
        STEM Podcasts
      </h2>
      <ul className="list-disc list-inside mt-4 career-resources__links leading-loose">
        <li>
          <a href="http://hellophd.com/">
            http://hellophd.com/
          </a>
        </li>
        <li>
          <a href="https://www.wnycstudios.org/shows/radiolab/">
            https://www.wnycstudios.org/shows/radiolab/
          </a>
        </li>
        <li>
          <a href="https://www.sciencefriday.com/">
            https://www.sciencefriday.com/
          </a>
        </li>
        <li>
          <a href="https://www.scientificamerican.com/multimedia/">
            https://www.scientificamerican.com/multimedia/
          </a>
        </li>
        <li>
          <a href="https://www.startalkradio.net/about-us/">
            https://www.startalkradio.net/about-us/
          </a>
        </li>
      </ul>
      <h2 className="uppercase text-xl font-bold mt-8">
        Books
      </h2>
      <ul className="list-disc list-inside career-resources__links mt-4 mb-16">
        <li>
          <a href="https://designingyour.life/the-book/">
            Designing your Life
          </a>
        </li>
        <li>
          <a href="https://www.amazon.com/Ikigai-Japanese-Secret-Long-Happy/dp/0143130722">
            Ikigai:
          </a>
          {' '}
          The Japanese Secret to a Long and Happy Life
        </li>
      </ul>
    </div>
  </Layout>
);

export default CareerResources;
